<template>
  <div id="GeneralInfoComponent">
    <v-card outlined
      ><v-card-title> {{ $t("vendor.headerStep1") }}</v-card-title
      ><v-card-text>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-row align="center" class="pa-4">
            <v-col cols="12" class="mb-4">
              <v-radio-group
                v-model="registerModel.vendorType"
                row
                :rules="vendorTypeRules"
                :disabled="formType === 'Edit'"
              >
                <template v-slot:label>
                  <div>{{ $t("vendor.selectType") }}<span>*</span></div>
                </template>
                <v-radio
                  label="Domestic"
                  value="domestic"
                  @click="setLocale('th')"
                ></v-radio>
                <v-radio
                  label="Overseas"
                  value="oversea"
                  @click="setLocale('en')"
                ></v-radio> </v-radio-group></v-col
            ><v-col cols="6">
              <v-select
                outlined
                dense
                v-model="registerModel.commercialTypeId"
                :items="commercialType"
                :rules="[
                  (v) => !!v || 'Commercial registration type is required',
                ]"
                :label="$t('vendor.commercialType')"
                required
                item-text="commercialTypeName"
                item-value="id"
              ></v-select></v-col
            ><v-col cols="6">
              <v-select
                outlined
                dense
                v-if="registerModel.commercialTypeId == '2'"
                v-model="registerModel.commercialPrefixId"
                :items="commercialPrefix"
                :rules="[(v) => !!v || 'Commercial registration is required']"
                :label="$t('vendor.commercialPrefix')"
                required
                item-text="commercialPrefixName"
                item-value="id"
              ></v-select></v-col
            ><v-col cols="12">
              <v-text-field
                outlined
                dense
                v-model="registerModel.companyNameEn"
                :rules="[(v) => !!v || 'Company Name is required']"
                :label="$t('vendor.companyNameEn')"
                required
              ></v-text-field></v-col
            ><v-col cols="12">
              <v-text-field
                outlined
                dense
                v-model="registerModel.companyNameTh"
                :label="$t('vendor.companyNameTh')"
                v-if="registerModel.vendorType === 'domestic'"
              ></v-text-field
            ></v-col>
            <v-col cols="6">
              <v-text-field
                :disabled="registerModel.isRegistered"
                outlined
                dense
                v-if="registerModel.vendorType === 'domestic'"
                v-model="registerModel.taxId"
                :rules="taxIdRules"
                :label="$t('vendor.taxId')"
                required
                counter="13"
                v-mask="'#############'"
              ></v-text-field
            ></v-col>
            <v-col cols="6">
              <v-text-field
                :disabled="registerModel.isRegistered"
                outlined
                dense
                v-if="registerModel.vendorType === 'domestic'"
                v-model="registerModel.branchId"
                counter="5"
                :label="$t('vendor.branchId')"
                v-mask="'#####'"
                :rules="branchIdRules"
              ></v-text-field
            ></v-col>
            <v-col cols="3">
              <v-text-field
                outlined
                dense
                v-model="registerModel.sapHouseNum1"
                :label="$t('vendor.address')"
                required
                :rules="[(v) => !!v || 'Address is required']"
              ></v-text-field
            ></v-col>
            <v-col cols="3" v-if="registerModel.vendorType === 'domestic'">
              <v-text-field
                outlined
                dense
                v-model="registerModel.sapStreet"
                :label="$t('vendor.moo')"
              ></v-text-field
            ></v-col>
            <v-col cols="3" v-if="registerModel.vendorType === 'domestic'">
              <v-text-field
                outlined
                dense
                v-model="registerModel.sapStrSuppl1"
                :label="$t('vendor.alley')"
              ></v-text-field
            ></v-col>
            <v-col cols="3">
              <v-text-field
                outlined
                dense
                v-model="registerModel.sapStrSuppl3"
                :label="$t('vendor.street')"
              ></v-text-field
            ></v-col>
            <v-col cols="6">
              <v-text-field
                outlined
                dense
                v-model="registerModel.sapStrSuppl2"
                :label="$t('vendor.city')"
                required
                :rules="[(v) => !!v || 'City / Sub-district is required']"
              ></v-text-field
            ></v-col>
            <v-col cols="6">
              <v-text-field
                outlined
                dense
                v-model="registerModel.sapCity2"
                :label="$t('vendor.state')"
                required
                :rules="[(v) => !!v || 'State / District  is required']"
              ></v-text-field
            ></v-col>

            <v-col cols="6">
              <v-text-field
                outlined
                dense
                v-model="registerModel.sapPostCode1"
                :label="$t('vendor.zipcode')"
                required
                :rules="[(v) => !!v || 'Zip code is required']"
                counter="5"
                v-mask="'#####'"
              ></v-text-field
            ></v-col>
            <v-col cols="6">
              <v-text-field
                outlined
                dense
                v-model="registerModel.companyTelephone"
                :label="$t('vendor.tel')"
                required
                :rules="[(v) => !!v || 'Telephone is required']"
                counter="20"
              ></v-text-field
            ></v-col>
            <v-col cols="6">
              <v-select
                outlined
                dense
                v-model="registerModel.countryId"
                :items="country"
                :rules="[(v) => !!v || 'Country is required']"
                :label="$t('vendor.country')"
                required
                item-text="countryName"
                item-value="id"
              ></v-select
            ></v-col>
            <v-col cols="6" v-if="registerModel.countryId === 221">
              <v-select
                outlined
                dense
                v-model="registerModel.provinceId"
                :items="province"
                :rules="[(v) => !!v || 'Province is required']"
                :label="$t('vendor.province')"
                required
                item-text="provinceName"
                item-value="id"
              ></v-select
            ></v-col>
            <v-col cols="6">
              <v-menu
                ref="menu"
                v-model="menuPicker"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="registerModel.companyEstablishDate"
                    :label="$t('vendor.companyEstablishDate')"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    dense
                    required
                    :rules="[
                      (v) => !!v || 'Company establishment date is required',
                    ]"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="registerModel.companyEstablishDate"
                  :active-picker.sync="activePicker"
                  :max="
                    new Date(
                      Date.now() - new Date().getTimezoneOffset() * 60000
                    )
                      .toISOString()
                      .substr(0, 10)
                  "
                  @change="save"
                ></v-date-picker> </v-menu></v-col
            ><v-col cols="6">
              <v-text-field
                v-if="isShowCompanyTurnOver"
                outlined
                dense
                v-model="registerModel.companyTurnOver"
                :label="$t('vendor.companyTurnOver')"
                :required="registerModel.vendorType === 'domestic'"
                :rules="rulesCompany"
                v-mask="currencyMask"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-menu
                ref="menu"
                v-model="menuPicker2"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="registerModel.companyTurnOverDate"
                    :label="$t('vendor.companyTurnOverDate')"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    dense
                    required
                    :rules="[
                      (v) => !!v || 'Company Turn Over Date is required',
                    ]"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="registerModel.companyTurnOverDate"
                  :active-picker.sync="activePicker2"
                  :max="
                    new Date(
                      Date.now() - new Date().getTimezoneOffset() * 60000
                    )
                      .toISOString()
                      .substr(0, 10)
                  "
                  @change="save"
                ></v-date-picker> </v-menu
            ></v-col>
            <v-col cols="6">
              <v-text-field
                v-mask="'##########'"
                outlined
                dense
                v-model="registerModel.numberofEmployees"
                :label="$t('vendor.numberofEmployees')"
              ></v-text-field
            ></v-col>
            <v-col cols="6">
              <v-text-field
                outlined
                dense
                v-model="registerModel.companyWebSite"
                :label="$t('vendor.companyWebSite')"
              ></v-text-field
            ></v-col>
            <v-col cols="6">
              <v-select
                outlined
                dense
                v-model="registerModel.currency"
                :items="currency_list"
                :rules="[(v) => !!v || 'Currency is required']"
                :label="$t('vendor.currency')"
                required
                item-text="code"
                item-value="code"
                @change="getcurrency(registerModel.currency)"
                class="form-select"
                id="currency"
                name="currency"
              >
              </v-select>
            </v-col>
            <v-col cols="6">
              <v-text-field
                outlined
                dense
                v-model="registerModel.fxrate"
                :label="$t('vendor.fxrate')"
                required
                :rules="rulesfxrate"
              ></v-text-field
            ></v-col>
            <v-col cols="6">
              <v-text-field
                disabled
                outlined
                dense
                v-model="registerModel.thbath"
                :label="$t('vendor.thbath')"
              ></v-text-field
            ></v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { masterservice } from "../../services/masterservice";

import { vendorservice } from "../../services/vendorservice";

import createNumberMask from "text-mask-addons/dist/createNumberMask";
const currencyMask = createNumberMask({
  prefix: "",
  allowDecimal: true,
  includeThousandsSeparator: true,
  allowNegative: true,
});
const currencyMask2 = createNumberMask({
  prefix: "",
  allowDecimal: true,
  includeThousandsSeparator: true,
  allowNegative: true,
  decimalLimit: 10,
});
export default {
  name: "GeneralInfoComponent",
  props: {
    propProvince: {
      type: Array,
      default: () => [],
    },
    propCountry: {
      type: Array,
      default: () => [],
    },
    propRegisterModel: {
      type: Object,
      default: () => {},
    },
    propCheckStep: {
      type: [Number, String],
      default: () => "",
    },
    formType: {
      type: String,
      default: "",
    },
  },
  data: () => ({
    currency_list: [
      { name: "Thai Baht", code: "THB" },
      { name: "Afghan Afghani", code: "AFA" },
      { name: "Albanian Lek", code: "ALL" },
      { name: "Algerian Dinar", code: "DZD" },
      { name: "Angolan Kwanza", code: "AOA" },
      { name: "Argentine Peso", code: "ARS" },
      { name: "Armenian Dram", code: "AMD" },
      { name: "Aruban Florin", code: "AWG" },
      { name: "Australian Dollar", code: "AUD" },
      { name: "Azerbaijani Manat", code: "AZN" },
      { name: "Bahamian Dollar", code: "BSD" },
      { name: "Bahraini Dinar", code: "BHD" },
      { name: "Bangladeshi Taka", code: "BDT" },
      { name: "Barbadian Dollar", code: "BBD" },
      { name: "Belarusian Ruble", code: "BYR" },
      { name: "Belgian Franc", code: "BEF" },
      { name: "Belize Dollar", code: "BZD" },
      { name: "Bermudan Dollar", code: "BMD" },
      { name: "Bhutanese Ngultrum", code: "BTN" },
      { name: "Bitcoin", code: "BTC" },
      { name: "Bolivian Boliviano", code: "BOB" },
      { name: "Bosnia-Herzegovina Convertible Mark", code: "BAM" },
      { name: "Botswanan Pula", code: "BWP" },
      { name: "Brazilian Real", code: "BRL" },
      { name: "British Pound Sterling", code: "GBP" },
      { name: "Brunei Dollar", code: "BND" },
      { name: "Bulgarian Lev", code: "BGN" },
      { name: "Burundian Franc", code: "BIF" },
      { name: "Cambodian Riel", code: "KHR" },
      { name: "Canadian Dollar", code: "CAD" },
      { name: "Cape Verdean Escudo", code: "CVE" },
      { name: "Cayman Islands Dollar", code: "KYD" },
      { name: "CFA Franc BCEAO", code: "XOF" },
      { name: "CFA Franc BEAC", code: "XAF" },
      { name: "CFP Franc", code: "XPF" },
      { name: "Chilean Peso", code: "CLP" },
      { name: "Chilean Unit of Account", code: "CLF" },
      { name: "Chinese Yuan", code: "CNY" },
      { name: "Colombian Peso", code: "COP" },
      { name: "Comorian Franc", code: "KMF" },
      { name: "Congolese Franc", code: "CDF" },
      { name: "Costa Rican Colón", code: "CRC" },
      { name: "Croatian Kuna", code: "HRK" },
      { name: "Cuban Convertible Peso", code: "CUC" },
      { name: "Czech Republic Koruna", code: "CZK" },
      { name: "Danish Krone", code: "DKK" },
      { name: "Djiboutian Franc", code: "DJF" },
      { name: "Dominican Peso", code: "DOP" },
      { name: "East Caribbean Dollar", code: "XCD" },
      { name: "Egyptian Pound", code: "EGP" },
      { name: "Eritrean Nakfa", code: "ERN" },
      { name: "Estonian Kroon", code: "EEK" },
      { name: "Ethiopian Birr", code: "ETB" },
      { name: "Euro", code: "EUR" },
      { name: "Falkland Islands Pound", code: "FKP" },
      { name: "Fijian Dollar", code: "FJD" },
      { name: "Gambian Dalasi", code: "GMD" },
      { name: "Georgian Lari", code: "GEL" },
      { name: "German Mark", code: "DEM" },
      { name: "Ghanaian Cedi", code: "GHS" },
      { name: "Gibraltar Pound", code: "GIP" },
      { name: "Greek Drachma", code: "GRD" },
      { name: "Guatemalan Quetzal", code: "GTQ" },
      { name: "Guinean Franc", code: "GNF" },
      { name: "Guyanaese Dollar", code: "GYD" },
      { name: "Haitian Gourde", code: "HTG" },
      { name: "Honduran Lempira", code: "HNL" },
      { name: "Hong Kong Dollar", code: "HKD" },
      { name: "Hungarian Forint", code: "HUF" },
      { name: "Icelandic Króna", code: "ISK" },
      { name: "Indian Rupee", code: "INR" },
      { name: "Indonesian Rupiah", code: "IDR" },
      { name: "Iranian Rial", code: "IRR" },
      { name: "Iraqi Dinar", code: "IQD" },
      { name: "Israeli New Sheqel", code: "ILS" },
      { name: "Italian Lira", code: "ITL" },
      { name: "Jamaican Dollar", code: "JMD" },
      { name: "Japanese Yen", code: "JPY" },
      { name: "Jordanian Dinar", code: "JOD" },
      { name: "Kazakhstani Tenge", code: "KZT" },
      { name: "Kenyan Shilling", code: "KES" },
      { name: "Kuwaiti Dinar", code: "KWD" },
      { name: "Kyrgystani Som", code: "KGS" },
      { name: "Laotian Kip", code: "LAK" },
      { name: "Latvian Lats", code: "LVL" },
      { name: "Lebanese Pound", code: "LBP" },
      { name: "Lesotho Loti", code: "LSL" },
      { name: "Liberian Dollar", code: "LRD" },
      { name: "Libyan Dinar", code: "LYD" },
      { name: "Litecoin", code: "LTC" },
      { name: "Lithuanian Litas", code: "LTL" },
      { name: "Macanese Pataca", code: "MOP" },
      { name: "Macedonian Denar", code: "MKD" },
      { name: "Malagasy Ariary", code: "MGA" },
      { name: "Malawian Kwacha", code: "MWK" },
      { name: "Malaysian Ringgit", code: "MYR" },
      { name: "Maldivian Rufiyaa", code: "MVR" },
      { name: "Mauritanian Ouguiya", code: "MRO" },
      { name: "Mauritian Rupee", code: "MUR" },
      { name: "Mexican Peso", code: "MXN" },
      { name: "Moldovan Leu", code: "MDL" },
      { name: "Mongolian Tugrik", code: "MNT" },
      { name: "Moroccan Dirham", code: "MAD" },
      { name: "Mozambican Metical", code: "MZM" },
      { name: "Myanmar Kyat", code: "MMK" },
      { name: "Namibian Dollar", code: "NAD" },
      { name: "Nepalese Rupee", code: "NPR" },
      { name: "Netherlands Antillean Guilder", code: "ANG" },
      { name: "New Taiwan Dollar", code: "TWD" },
      { name: "New Zealand Dollar", code: "NZD" },
      { name: "Nicaraguan Córdoba", code: "NIO" },
      { name: "Nigerian Naira", code: "NGN" },
      { name: "North Korean Won", code: "KPW" },
      { name: "Norwegian Krone", code: "NOK" },
      { name: "Omani Rial", code: "OMR" },
      { name: "Pakistani Rupee", code: "PKR" },
      { name: "Panamanian Balboa", code: "PAB" },
      { name: "Papua New Guinean Kina", code: "PGK" },
      { name: "Paraguayan Guarani", code: "PYG" },
      { name: "Peruvian Nuevo Sol", code: "PEN" },
      { name: "Philippine Peso", code: "PHP" },
      { name: "Polish Zloty", code: "PLN" },
      { name: "Qatari Rial", code: "QAR" },
      { name: "Romanian Leu", code: "RON" },
      { name: "Russian Ruble", code: "RUB" },
      { name: "Rwandan Franc", code: "RWF" },
      { name: "Salvadoran Colón", code: "SVC" },
      { name: "Samoan Tala", code: "WST" },
      { name: "São Tomé and Príncipe Dobra", code: "STD" },
      { name: "Saudi Riyal", code: "SAR" },
      { name: "Serbian Dinar", code: "RSD" },
      { name: "Seychellois Rupee", code: "SCR" },
      { name: "Sierra Leonean Leone", code: "SLL" },
      { name: "Singapore Dollar", code: "SGD" },
      { name: "Slovak Koruna", code: "SKK" },
      { name: "Solomon Islands Dollar", code: "SBD" },
      { name: "Somali Shilling", code: "SOS" },
      { name: "South African Rand", code: "ZAR" },
      { name: "South Korean Won", code: "KRW" },
      { name: "South Sudanese Pound", code: "SSP" },
      { name: "Special Drawing Rights", code: "XDR" },
      { name: "Sri Lankan Rupee", code: "LKR" },
      { name: "St. Helena Pound", code: "SHP" },
      { name: "Sudanese Pound", code: "SDG" },
      { name: "Surinamese Dollar", code: "SRD" },
      { name: "Swazi Lilangeni", code: "SZL" },
      { name: "Swedish Krona", code: "SEK" },
      { name: "Swiss Franc", code: "CHF" },
      { name: "Syrian Pound", code: "SYP" },
      { name: "Tajikistani Somoni", code: "TJS" },
      { name: "Tanzanian Shilling", code: "TZS" },

      { name: "Tongan Pa'anga", code: "TOP" },
      { name: "Trinidad & Tobago Dollar", code: "TTD" },
      { name: "Tunisian Dinar", code: "TND" },
      { name: "Turkish Lira", code: "TRY" },
      { name: "Turkmenistani Manat", code: "TMT" },
      { name: "Ugandan Shilling", code: "UGX" },
      { name: "Ukrainian Hryvnia", code: "UAH" },
      { name: "United Arab Emirates Dirham", code: "AED" },
      { name: "Uruguayan Peso", code: "UYU" },
      { name: "US Dollar", code: "USD" },
      { name: "Uzbekistan Som", code: "UZS" },
      { name: "Vanuatu Vatu", code: "VUV" },
      { name: "Venezuelan BolÃvar", code: "VEF" },
      { name: "Vietnamese Dong", code: "VND" },
      { name: "Yemeni Rial", code: "YER" },
      { name: "Zambian Kwacha", code: "ZMK" },
      { name: "Zimbabwean dollar", code: "ZWL" },
    ],
    activePicker: null,
    activePicker2: null,
    menuPicker: false,
    menuPicker2: false,
    valid: true,
    currencyMask,
    currencyMask2,

    name: "",
    isShowCompanyTurnOver: false,
    taxIdRules: [
      (v) => !!v || "Tax ID is required",
      (v) => (v && v.length >= 13) || "Tax ID must be less than 13 characters",
    ],
    branchIdRules: [
      (v) => !v || v.length === 5 || "branch Id must be less than 5 characters",
    ],
    rulesCompany: [
      (v) => !!v || "Company's Net Profit is requiredaa",
      // (v) =>
      //   (v && v.replace(/,/g, "") > 0) ||
      //   "Company's Net Profit  must be more than 0 baht",
    ],
    rulesfxrate: [(v) => !!v || "Fx Rate is required"],
    email: "",
    emailRules: [
      (v) => !!v || "E-mail is required",
      (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
    ],
    vendorTypeRules: [(v) => !!v || "Vendor type is required"],
    select: null,
    items: ["Item 1", "Item 2", "Item 3", "Item 4"],
    checkbox: false,

    commercialType: [],
    commercialPrefix: [],
    province: [],
    country: [],
    // Model
    registerModel: {
      vendorId: 0, // New vendor
      taxId: "",
      branchId: "",
      commercialTypeId: 0,
      commercialPrefixId: 0,
      companyNameTh: "",
      companyNameEn: "",
      countryId: 0,
      provinceId: 0,
      companyAddress: "",
      commercialType: "",
      companyWebSite: "",
      currency: "",
      fxrate: 0,
      thbath: 0,
      companyEstablishDate: "",
      companyTurnOverDate: "",
      //companyTurnOver: "",
      numberofEmployees: 0,
      companyTelephone: "",
      registeredCapital: 0,
      experienceIn: "",
      experienceYear: 0,
      isoname: "",
      licenseName: "",
      isConsent: false,
      // SAP Field
      sapStreet: "",
      sapStrSuppl1: "",
      sapStrSuppl2: "",
      sapHouseNum1: "",
      sapHouseNum2: "",
      sapStrSuppl3: "",
      sapLocation: "",
      sapCity2: "",
      sapPostCode1: "",
      sapPostCity1: "",
      sapCountry: "",
      sapLangu: "",
      sapTelNumber: "",
      sapMobNumber: "",
      sapFaxNumber: "",
      sapAdr6SmtpAddr: "",
      vendorType: "",
      isRegistered: false,
    },
  }),
  watch: {
    propCountry(value) {
      if (value) this.country = value;
    },
    propProvince(value) {
      if (value) this.province = value;
    },
    propRegisterModel(value) {
      if (this.formType === "Edit") {
        this.registerModel = value;
        this.registerModel.companyTurnOver = value.companyTurnOver
          ? value.companyTurnOver
          : 0;
        this.registerModel.companyTurnOverDate = value.companyTurnOverDate
          ? value.companyTurnOverDate
          : Date.now();
        this.isShowCompanyTurnOver = true;
        if (this.registerModel.vendorType === "domestic") this.setLocale("th");
        else this.setLocale("en");
        this.registerModel.companyEstablishDate = this.moment(
          this.registerModel.companyEstablishDate
        ).format("yyyy-MM-DD");
        this.registerModel.companyTurnOverDate = this.moment(
          this.registerModel.companyTurnOverDate
        ).format("yyyy-MM-DD");
      } else {
        this.isShowCompanyTurnOver = true;
      }
    },
    propCheckStep(value) {
      if (value === 1) {
        this.validate();
      }
    },
    "registerModel.vendorType"(value) {
      if (this.formType === "Register") {
        if (value === "domestic") {
          this.registerModel.countryId = 221;
        } else {
          this.registerModel.countryId = 0;
        }
      }
    },
    "registerModel.fxrate"(value) {
      const withoutCommas = this.registerModel.companyTurnOver.replaceAll(
        ",",
        ""
      );
      this.registerModel.thbath = withoutCommas * value;
    },
    "registerModel.companyTurnOver"(value) {
      const withoutCommas = value.replaceAll(",", "");
      this.registerModel.thbath = withoutCommas * this.registerModel.fxrate;
    },
    menuPicker(val) {
      val && setTimeout(() => (this.activePicker = "YEAR"));
    },
    menuPicker2(val) {
      val && setTimeout(() => (this.activePicker2 = "YEAR"));
    },
  },
  async created() {
    await this.getCommercialType();
    await this.getCommercialPrefix();
    if (this.formType === "Register") {
      this.isShowCompanyTurnOver = true;
    }
  },
  methods: {
    async validate() {
      await this.$refs.form.validate();
      if (this.valid === true) {
        if (this.formType === "Register") {
          if (await this.checkTxtId()) {
            this.$emit("EmitDataInfo", this.registerModel);
          }
        } else {
          this.$emit("EmitDataInfo", this.registerModel);
        }
      }
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    save(date) {
      this.$refs.menu.save(date);
    },
    async getCommercialType() {
      this.commercialType = await masterservice.GetMasterCommercialType();
    },
    async getcurrency(symbols) {
      if (symbols == "THB") {
        this.registerModel.fxrate = 1;
      } else {
        const currentDate = new Date();

        // Subtract one day's worth of milliseconds (86400000 milliseconds in a day)
        const previousDate = new Date(currentDate.getTime() - 86400000);

        // Get individual components of the previous date
        const year = previousDate.getFullYear();
        const month = String(previousDate.getMonth() + 1).padStart(2, "0");
        const day = String(previousDate.getDate()).padStart(2, "0");

        // Display the previous date in "yyyy-dd-mm" format
        const formattedPreviousDate = `${year}-${month}-${day}`;

        var cur = await masterservice.GetCurrency(
          symbols,
          formattedPreviousDate
        );

        if (cur != null) {
          this.registerModel.fxrate = cur.rate;
          //this.registerModel.fxrat=10;
        } else {
          this.registerModel.fxrate = 0;
        }
      }
    },
    async getCommercialPrefix() {
      this.commercialPrefix = await masterservice.GetMasterCommercialPrefix();
    },
    async checkTxtId() {
      this.$loading(true);
      let msg = "";
      let isValid = true;
      if (this.registerModel.vendorType === "domestic") {
        if (
          this.registerModel.taxId.length >= 13 ||
          isNaN(this.registerModel.taxId)
        ) {
          if (+this.registerModel.branchId <= 0) {
            this.registerModel.branchId = "00000";
          }
          const res = await vendorservice.GetVendorExist(
            this.registerModel.taxId,
            this.registerModel.branchId
          );
          if (res.result) {
            msg =
              "*Tax ID (หมายเลขประจำตัวผู้เสียภาษี) มีอยู่ในระบบแล้ว" + "<br>";
            isValid = false;
          }
        } else {
          msg = "*Tax ID (หมายเลขประจำตัวผู้เสียภาษี) ไม่ถูกต้อง" + "<br>";
          isValid = false;
        }
      }
      if (!isValid) {
        this.$notify({
          title: "Cann't goto next step!",
          text: msg,
          type: "error",
        });
      }
      this.$loading(false);
      return isValid;
    },
    setLocale(locale) {
      this.$i18n.locale = locale;
      this.$router
        .push({
          params: {
            lang: locale,
          },
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.col {
  padding: 0 0.5rem;
}
</style>
